/** @file uniqueNodeName: a node name not yet used by the puppet (`base`, then `base2`, `base3`, ...). */

/** `base` when free, else the first `base<n>` (n >= 2) that `nodes` does not hold. */
export function uniqueNodeName(nodes: Record<string, unknown>, base: string): string {
  if (!(base in nodes)) return base;
  let n = 2;
  while (`${base}${n}` in nodes) n++;
  return `${base}${n}`;
}
